import React from 'react';

interface TabsPanePropsInterface {
    children: React.ReactNode;
    value: string;
    activeTab: string;
}

export const TabsPanel: React.FC<TabsPanePropsInterface> = ({ children, value, activeTab }) => {
    if (value === activeTab) {
        return <div>{children}</div>;
    }

    return null;
};
